module.exports = __webpack_public_path__ + "img/911-carrera.d698a23b.png";